// Returns the index of a given tab (EG 'general', 'preferences') in a panes array (semantic-ui)
export const getPanesTabIndex = (tabPanes, tab) => {
  // semantic-ui panes should have this `.menuItem.key` structure
  return tabPanes.findIndex(obj => obj.menuItem?.key === tab)
}
